<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!-- 
    <el-select
      @change="changeOnecoursetype"
      v-model="Type"
      placeholder="请选择课程类型"
    >
      <el-option label="--请选择--" value="0"></el-option>
      <el-option label="音频" value="1"></el-option>
      <el-option label="视频" value="2"></el-option>
      <el-option label="图文" value="3"></el-option>
    </el-select>

    <el-select
      @change="changecoursetype"
      v-model="CourseTypeId"
      placeholder="请选择主题类型"
    >
      <el-option
        v-for="(item, index) in coursetypelist"
        :key="index"
        :label="item.Name"
        :value="item.Id"
      ></el-option>
    </el-select>

    <el-select v-model="CourseId" placeholder="请选择">
      <el-option
        v-for="(item, index) in courselist"
        :key="index"
        :label="item.Name"
        :value="item.Id"
      ></el-option>
    </el-select> -->

    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <el-table-column type="selection" width="100"></el-table-column>
      <!-- <el-table-column prop="Id" label="ID" width></el-table-column> -->
      <el-table-column
        prop="Name"
        label="习题标题"
        width
        sortable
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="ContentTime" label="选项" width sortable>
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.AnswerListstring" :key="index">
            {{ item }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ContentTime" label="正确答案" width sortable>
        <template slot-scope="scope">
          {{ scope.row.AnswerBool }}
        </template>
      </el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        width
        sortable
      ></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      >
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="15"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px" ref="editForm">
        <el-form-item label="习题内容" prop="Name">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="editForm.Name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col
            :span="12"
            v-for="(i, index) in editForm.AnswerLsit"
            :key="index"
          >
            <el-form-item :label="'选项' + EnglishList[index]" width sortable>
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入内容"
                v-model="editForm.AnswerLsit[index].Content"
              ></el-input>
              <!-- @change="ChangeSave(index)"          -->
              <!-- if (imgList.length < 3) imgList.push({ content: "", picUrl: "" }); -->
              <el-radio-group v-model="radio">
                <el-radio
                  @change="ChangeSave(index, 'Edit')"
                  :label="EnglishList[index]"
                ></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item>
          <el-button @click.native="addOption">添加选项</el-button>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFromVisibleShow"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="90px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="习题内容" prop="Name">
          <el-input v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col
            :span="12"
            v-for="(i, index) in addForm.NewAnswers_lists"
            :key="index"
          >
            <el-row>
              <el-form-item
                :label="'选项' + EnglishList[index]"
                width
                sortable
                :inline="true"
              >
                <el-col :span="16">
                  <el-input
                    style="display: inline"
                    v-model="addForm.NewAnswers_lists[index].Content"
                    auto-complete="off"
                  >
                  </el-input>
                </el-col>
                <el-col :span="2"> </el-col>
                <el-col :span="4">
                  <el-button
                    style="float: right"
                    type="danger"
                    icon="el-icon-delete"
                    @click.native="EidtOption(index)"
                    circle
                  ></el-button>
                </el-col>
                <el-col :span="24">
                  <el-radio-group v-model="radio">
                    <el-radio
                      @change="ChangeSave(index, 'Add')"
                      :label="EnglishList[index]"
                    ></el-radio>
                  </el-radio-group>
                </el-col>
                <!-- @change="ChangeSave(index)"          -->
                <!-- if (imgList.length < 3) imgList.push({ content: "", picUrl: "" }); -->
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-button @click.native="addOption">添加选项</el-button>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFromVisibleShow = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
// import util from "../../../util/date";
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
  Y_SelectQuerstionList,
  getcoursetypes,
  Y_AddQuerstion,
  coursecatalogsupdate,
  coursecatalogsdelete,
  getCourseListBacks,
  OtherUpload,
  Y_LookQuerstion,
  Y_EditQuerstion,
  UploadImg,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar, quillEditor },
  data() {
    return {
      EnglishList: ["A", "B", "C", "D", "E", "F", "G", "H", "Y", "J"],
      CourseTypeId: null,
      CourseId: null,
      Type: "0",
      editorOption: {},
      dialogVisible: false,
      limitNum: 1,
      buttonList: [],
      coursetypelist: [{ Id: 0, Name: "请选择" }],
      courselist: [{ Id: 0, Name: "请选择" }],
      currentRow: null,

      filters: {
        name: "",
      },
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,

      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: "",
        LinkUrl: "",
        Name: "",
        Enabled: false,
      },

      addFromVisibleShow: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请题目", trigger: "blur" }],
        CourseId: [{ required: true, message: "主课程Id", trigger: "blur" }],
        Briefing: [{ required: true, message: "简介", trigger: "blur" }],
        Content: [{ required: true, message: "详情", trigger: "blur" }],
        ContentUrl: [{ required: true, message: "资源内容", trigger: "blur" }],
      },
      radio: "",
      //新增界面数据
      addForm: {
        TenantId: null,
        Name: "",
        NewAnswers_lists: [
          { Id: 1, Content: null, IsRigth: false },
          { Id: 2, Content: null, IsRigth: false },
        ],
      },
    };
  },
  methods: {
    addOption() {
      this.addForm.NewAnswers_lists.push({
        Id: this.addForm.NewAnswers_lists.length + 1,
        Content: null,
        IsRigth: false,
      });
    },
    EidtOption(index) {
      this.addForm.NewAnswers_lists.splice(index, 1);
    },
    ChangeSave(index, status) {
      console.log(index);
      if (status == "Add") {
        this.addForm.NewAnswers_lists.forEach((element) => {
          element.IsRigth == false;
        });
        this.addForm.NewAnswers_lists[index].IsRigth = true;
      } else {
        this.editForm.AnswerLsit.forEach((element) => {
          element.IsRigth == false;
        });
        this.editForm.AnswerLsit[index].IsRigth = true;
      }
    },
    onEditorReady(editor) {},

    // 上传文件个数超过定义的数量
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    // 上传文件之前的钩子
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "mp3";
      const extension2 = testmsg === "mp4";
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是mp3或mp4格式！",
          type: "error",
        });
      }

      return extension;
    },
    // 上传文件
    uploadFile(item) {
      console.log(item);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("comId", this.comId);

      console.log(form);
      OtherUpload(form).then((response) => {
        console.log("MediaAPI.upload");
        console.log(response);
        this.addForm.ContentUrl = response.data.url;
        console.log("filename", this.addForm.ContentUrl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    //获取课程类型
    getcoursetypelist() {
      getcoursetypes({ CurriculumType: 1, Type: 1 }).then((res) => {
        console.log(res);
        this.coursetypelist = res.data.response;
      });
    },
    //获取类别后查询类容
    changeOnecoursetype() {
      this.getLists();
    },
    changecoursetype(val) {
      // this.Type=val;
      getCourseListBacks({ CourseTypeId: val }).then((res) => {
        this.courselist = res.data.response;
        if (res.data.response.length > 0) this.CourseId = null;
      });
      this.getLists();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
      console.log(this.currentRow);
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    formattypename: function (row, column) {
      let typename = "其他";
      switch (row.Type) {
        case 1:
          typename = "音频";
          break;
        case 2:
          typename = "视频";
          break;
        case 3:
          typename = "图文";
          break;
      }
      return typename;
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == "" ? "" : row.CreateTime;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getLists();
    },
    //获取列表
    getLists() {
      let para = {
        PageIndex: this.page,
        Name: this.filters.name,
        Id: 1,
      };
      this.listLoading = true;
      Y_SelectQuerstionList(para).then((res) => {
        console.log(res);

       if (res.data.success) {
          this.users = res.data.response.data;
          this.total = res.data.response.dataCount;
          this.listLoading = false;
          console.log(this.users);
        } else {
           this.users = [];
          this.total =0;
          this.listLoading = false;
        }
      });
    },
    //删除
    handleDel() {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
      return;
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { catalogsId: row.Id };
          coursecatalogsdelete(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getLists();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      let para = {
        Id: row.Id,
      };
      console.log(row);
      Y_LookQuerstion(para).then((res) => {
        if (res.data.success) {
          this.editFormVisible = true;
          this.editForm = res.data.response;
          for (
            let index = 0;
            index < res.data.response.AnswerLsit.length;
            index++
          ) {
            if (res.data.response.AnswerLsit[index].IsRigth) {
              this.radio = this.EnglishList[index];
            }
          }
        }
      });
      // this.$message({
      //   message: "功能正在陆续开发中...",
      //   type: "error",
      // });
    },
    // 查詢事件
    getMoudle() {
      // this.$message({
      //   message: "该功能未开放",
      //   type: "warning",
      // });
      // return;
      this.getLists();
    },
    //显示新增界面
    handleAddShow() {
      this.addFromVisibleShow = true;
      this.addForm = {
        TenantId: 12,
        Name: "",
        NewAnswers_lists: [
          { Id: 1, Content: null, IsRigth: false },
          { Id: 2, Content: null, IsRigth: false },
        ],
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            Y_EditQuerstion(this.editForm).then((res) => {
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getLists();
              } else {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            console.log(_this.addForm);
            this.addLoading = true;
            let popr = {
              TenantId: this.addForm.MainId,
              Name: this.addForm.Name,
              NewAnswers_lists: this.addForm.NewAnswers_lists,
            };
            Y_AddQuerstion(popr).then((res) => {
              console.log(res);
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFromVisibleShow = false;
                this.getLists();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  mounted() {
    this.getLists();

    this.getcoursetypelist();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
</style>
